import { Controller } from "@hotwired/stimulus"

// Fades the element out after a delay. Used for the transient "Saved" badge.
// Configure with `data-auto-dismiss-delay-value` (default 1500ms).
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 1500 },
    fade: { type: Number, default: 400 }
  }

  connect() {
    this.element.style.transition = `opacity ${this.fadeValue}ms ease`
    this.timer = setTimeout(() => {
      this.element.style.opacity = "0"
    }, this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }
}
